import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import { FaTimes } from 'react-icons/fa'

export const StyledCancelButton = styled(Button)`
  border: 0;
  margin-top: 1rem;
  background-color: ${(props) => props.theme.button.secondary};

  > span {
    font-size: 0.8rem;
  }
`

export const Times = styled(FaTimes)`
  font-size: 1.1rem;
`
